import { isRecord } from '@/shared/utils/isRecord';
import type { ApiError, ApiErrorBody } from '@/shared/model/types/http';

export const isApiErrorBody = (value: unknown): value is ApiErrorBody =>
  isRecord(value) && typeof value.message === 'string';

export const isApiError = (error: unknown): error is ApiError =>
  isRecord(error) && typeof error.status === 'number' && isRecord(error.response);
